module.exports = __webpack_public_path__ + "static/bg-02e9ac5f5158264edef94aab0aa17c1e.png";